import script from "./blend-constituent-editor.vue?vue&type=script&setup=true&lang=js"
export * from "./blend-constituent-editor.vue?vue&type=script&setup=true&lang=js"

import "./blend-constituent-editor.vue?vue&type=style&index=0&id=15c8ab5c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15c8ab5c"]])

export default __exports__